// src/pages/UnderstandingTwitches.js

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function UnderstandingTwitches() {
  return (
    <>
      {/* Inline Style for Montserrat if you don’t have a global CSS */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');

          body, h1, h2, h3, h4, h5, h6, p, .btn, .navbar-brand, .nav-link {
            font-family: 'Montserrat', sans-serif !important;
          }
        `}
      </style>

      {/* ========== HERO BANNER ========== */}
      <div
        style={{
          backgroundColor: '#c8102e',
          color: '#fff',
          padding: '6rem 0',
          textAlign: 'center',
        }}
      >
        <Container>
          <h1 style={{ fontWeight: '700', fontSize: '2.5rem' }}>
            Understanding Muscle Twitches
          </h1>
          <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '1rem auto' }}>
            Explore the causes and common misconceptions around muscle twitching, and learn how it
            relates to BFS.
          </p>
        </Container>
      </div>

      {/* ========== ARTICLE CONTENT ========== */}
      <div style={{ backgroundColor: '#f5f5f5', padding: '4rem 0' }}>
        <Container>
          <Row className="justify-content-center">
            <Col md={10}>
              <h2 style={{ fontWeight: '700', marginBottom: '1.5rem' }}>What Are Muscle Twitches?</h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                A muscle twitch—also known as a fasciculation—occurs when small muscle fibers
                involuntarily contract. These contractions typically last for a few seconds
                and may recur sporadically, sometimes causing concern for those who experience them.
              </p>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                In the context of <strong>Benign Fasciculation Syndrome (BFS)</strong>, twitches
                are considered non-life-threatening but can nevertheless be disruptive or anxiety-provoking.
                Common sites include the eyelids, arms, legs, and even the tongue.
              </p>

              <h3 style={{ fontWeight: '700', marginTop: '2rem', marginBottom: '1rem' }}>
                Potential Causes & Triggers
              </h3>
              <ul style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                <li><strong>Stress & Anxiety:</strong> Elevated stress hormones can heighten nerve sensitivity.</li>
                <li><strong>Caffeine Intake:</strong> Excess coffee or energy drinks may exacerbate twitching.</li>
                <li><strong>Fatigue & Sleep Deprivation:</strong> Tired muscles and nerves are more prone to random firing.</li>
                <li><strong>Nutritional Imbalances:</strong> Low magnesium or electrolyte levels might play a role.</li>
              </ul>

              <h3 style={{ fontWeight: '700', marginTop: '2rem', marginBottom: '1rem' }}>
                Debunking Common Misconceptions
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                Muscle twitches are frequently misunderstood. While they can mirror symptoms of more serious
                neurological conditions, fasciculations alone are not a definitive sign of diseases like ALS 
                or MS. A thorough evaluation by a healthcare provider usually rules out these conditions when 
                BFS is suspected.
              </p>

              <h3 style={{ fontWeight: '700', marginTop: '2rem', marginBottom: '1rem' }}>
                When to Seek Medical Advice
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                If muscle twitching is accompanied by muscle weakness, significant atrophy, or other progressive 
                neurological symptoms, consult a medical professional for a comprehensive evaluation. However, 
                most cases of sporadic twitching—especially those fitting the pattern of BFS—remain benign.
              </p>

              <h3 style={{ fontWeight: '700', marginTop: '2rem', marginBottom: '1rem' }}>
                Managing & Coping with Twitches
              </h3>
              <ul style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                <li><strong>Stress Reduction:</strong> Practice mindfulness, meditation, or relaxation exercises.</li>
                <li><strong>Healthy Habits:</strong> Get ample sleep, hydrate well, and maintain a balanced diet.</li>
                <li><strong>Limit Stimulants:</strong> Consider reducing caffeine or nicotine intake.</li>
                <li><strong>Community Support:</strong> Connect with others experiencing BFS for shared advice and reassurance.</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default UnderstandingTwitches;
